import TextEditor from "../compose/TextEditor";
import {useAppDispatch, useAppSelector, useAppStore} from "../../hooks/ReduxHooks";
import {shallowEqual} from "react-redux";
import {NotesActions} from "../../redux/NotesSlice";
import {TextEditorFileCallback} from "../compose/TextEditorFileCallback";
import {readFileAsDataURL} from "../../util/ImageUtil";
import React from "react";


const RenderNoteEditPageContent = () => {
    const editingPage = useAppSelector(({notesState}) => notesState.editingPage, shallowEqual);
    const selectedPage = useAppSelector(({notesState}) => notesState.selectedPage, shallowEqual);

    const dispatch = useAppDispatch();
    const store = useAppStore();

    const instanceId = "notes_" + selectedPage?.ClientSectionId + "_" + selectedPage?.ClientId;
    console.log("InstanceId", instanceId);

    async function onChangeNoteContent(html: string) {
        dispatch(NotesActions.setEditNoteContent(html));
    }

    async function onSave() {
        const newPage = {...editingPage!, HtmlContent: store.getState().notesState.editPageContent};
        dispatch(await NotesActions.completeEditNote(newPage, true));
    }

    if (!editingPage && !selectedPage) {
        return null;
    }

    async function handleAddInlineImageAttachment(callback: TextEditorFileCallback, file: File) {
        // Show the image inline
        callback(await readFileAsDataURL(file), {alt: file.name});
    }

    return (
        <TextEditor instanceId={instanceId}
                    statusbar={false}
                    menubar={false} //edit insert format table tools help"
                    toolbar="undo redo | bold italic underline formatpainter removeformat | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table | link image media | forecolor backcolor emoticons codesample code | searchreplace "
                    plugins={["autolink", "image", "paste", "table", "media", "searchreplace", "lists", "emoticons", "code", "codesample", "save"]}
                    initialValue={editingPage?.HtmlContent ?? selectedPage?.HtmlContent ?? ""}
                    onChange={onChangeNoteContent}
                    onSave={onSave}
                    mode={editingPage ? "design" : "readonly"}

                    onAddInlineImage={(callback, file) => handleAddInlineImageAttachment(callback, file)}
        />
    );
};

export const NoteEditPageContent = React.memo(RenderNoteEditPageContent);
